import React, { useEffect, useState } from "react";
import api from "../../../apiClient";
import { clean, dateTime, plainWords } from "../customerFormat";
import { frIdOf, TabState } from "./tabShared";

const toRows = (v) => (Array.isArray(v) ? v : Array.isArray(v?.results) ? v.results : []);

// Abon work orders for this customer (filtered server-side). FieldRoutes-run
// businesses keep their visit record in FieldRoutes — the Appointments tab.
export default function WorkOrdersTab({ record }) {
  const customerPk = record?.object !== "lead" ? record?.raw?.id : null;
  const onFieldRoutes = Boolean(frIdOf(record));
  const [state, setState] = useState("loading");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!customerPk) {
      setState("none");
      return undefined;
    }
    let alive = true;
    (async () => {
      setState("loading");
      try {
        const { data } = await api.get("/scheduling/work-orders/", { params: { customer_id: customerPk } });
        if (!alive) return;
        setRows(toRows(data));
        setState("ok");
      } catch {
        if (alive) setState("error");
      }
    })();
    return () => {
      alive = false;
    };
  }, [customerPk]);

  if (state === "none") return <TabState>Work orders are kept on customer records. Convert this lead to see them.</TabState>;
  if (state === "loading") return <TabState>Loading work orders…</TabState>;
  if (state === "error") return <TabState>Couldn't load work orders. Try again in a moment.</TabState>;
  if (!rows.length) {
    return (
      <TabState>
        No Abon work orders for this customer.
        {onFieldRoutes ? " Visits for this account are run in FieldRoutes — see the Appointments tab." : ""}
      </TabState>
    );
  }

  return (
    <section className="cov-card">
      <div className="cov-card__head">
        <span>Work orders</span>
        <span className="cov-card__count">{rows.length}</span>
      </div>
      <div className="cov-card__body">
        {rows.map((row) => (
          <div key={row.id} className="cov-row">
            <div className="cov-row__main ct-row-main-wide">
              <span className="cov-row__title">{clean(row.title) || "Work order"}</span>
              <span className="cov-row__meta">{dateTime(row.start_time || row.updated_at || row.created_at)}</span>
              {clean(row.notes) ? <span className="ct-note">{clean(row.notes)}</span> : null}
            </div>
            <span className="cov-pill cov-pill--muted">{plainWords(row.status) || "Open"}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
